import React, { memo } from 'react'
import { LockedFilledIcon } from 'transfix-icons'
import { Tooltip } from 'transfix-ui'

interface ILockedTooltipProps {
  className: string
}

export const LockedTooltip = memo<ILockedTooltipProps>(({ className }) => {
  return (
    <Tooltip
      position='top'
      type='dark'
      trigger={
        <span className={className}>
          <LockedFilledIcon size='large' />
        </span>
      }>
      <div className='body-bold tc'>This field is locked and can&apos;t be edited.</div>
      <div className='text-secondary body-semibold tc'>
        This info is managed by Transfix. It will be updated automatically if Transfix makes a
        change.
      </div>
    </Tooltip>
  )
})
